import {  USERS_API } from "@/utils/apiUrl"
import backend from "@/utils/backend"
import * as types from "./mutation_types"



export const getAll = ({ commit }) => {
    const url = USERS_API
    commit(types.SET_SHOW_LOADING)
    backend({ url, data: null, method: "GET" }).then(({ data }) => {
        commit(types.SET_ITEMS, data?.data ?? data)
        commit(types.SET_IS_SUCCESS)
        commit(types.SET_USER,data.user ?? "Super")
        commit(types.SET_CURRENT_ITEM, null)
    }).catch((err) => {
        commit(types.SET_IS_ERROR)
        commit(types.SET_SHOW_USER)

       
        commit(types.SET_USER, (err?.response?.user ?? err.user ?? err))
    }).finally(() => {
        commit(types.SET_SHOW_USER)
        commit(types.SET_HIDE_LOADING)
      
    })
}


export const resetData = ({ commit }) => {
    commit(types.RESET)
}



